import React from 'react';

import { Box } from '@mui/material';

import { formatExtraNightRate } from './formatExtraNightRate';

/** Small warning-colored inline label used wherever a field needs to flag "this is an admin override". */
export function AdminOverrideCaption() {
  return (
    <Box component="span" sx={{ color: 'warning.main', fontWeight: 600 }}>
      Admin override
    </Box>
  );
}

/**
 * Inline `helperText` for a points override field, surfacing whether its current value is
 * admin-overridden or still the frozen formula value:
 * - Reward has no manual override at all → `undefined` (field renders exactly as before this
 *   feature — no extra helper).
 * - This specific field is overridden (per `override_meta.fields`) → the "Admin override" caption.
 * - Reward is overridden, but NOT this field → `Formula: {computedValue}`, so the admin can see
 *   what auto-pilot last computed without leaving the dialog. `computedValue` is only ever null
 *   for the extra-night rate (no nightly price), shown as not applicable rather than 0.
 */
export function pointsFieldHelperText(
  isManualOverride: boolean,
  isFieldOverridden: boolean,
  computedValue: number | null,
): React.ReactNode {
  if (!isManualOverride) {
    return undefined;
  }
  if (isFieldOverridden) {
    return <AdminOverrideCaption />;
  }
  return `Formula: ${formatExtraNightRate(computedValue)}`;
}
